export default __webpack_public_path__ + "580efb4b24b29404965822795b02d789.png";